export interface ProfilePicture {
  url: string;
  mimeType: string;
}

export interface State {
  id: string;
  name: string;
}

export interface City {
  id: string;
  name: string;
}

export interface PrimaryUser {
  id: string;
  name: string;
}
export interface Address {
  line1: string;
  line2: string;
  zipCode: string;
  state: State;
  city: City;
}

export enum RecordType {
  Prescription = 1,
  LabReport = 2,
  DischargeSummary = 3,
  Imaging = 4,
  Other = 5,
  Vital = 6,
  EPrescription = 7,
}

export interface Member {
  dob: string;
  gender: number;
  id: string;
  name: string;
  profilePicture: ProfilePicture;
  profilePictureUrl: string;
  relationship: number;
}

export interface UserModelBase {
  id: string;
  name: string;
  mobileNumber: string;
  emailAddress: string;
  profilePictureUrl: string;
  profilePicture: ProfilePicture;
  members: Member[];

  address: Address;

  activated: boolean;

  bloodGroup: number;

  gender: Gender;
  isDeleted?: boolean;
}

export interface UserModel extends UserModelBase {
  roles: number[];
}

export interface SingleUserModel extends UserModelBase {
  dob: string;
  age: string;
  role: number;
  clinic: PrimaryUser;
  primaryUserId?: string;
  primaryUser?: PrimaryUser;
  medicalLicenseImage: string;
  roles: number[];
  primaryUserDeletedAt: boolean;
  isActive?: boolean;

  licence20?: LicenseDetails;
  licence21?: LicenseDetails;
  fssai?: LicenseDetails;
  digitalSignature?: DigitalSignatureDetails;
  digitalSignatureUrl?: string;
  uhid?: string;
  patientAppHomeScreen?: boolean;
  patientAppDoctorListing?: boolean;
}

export interface LicenseDetails {
  licenceNo: string;
  expiryDate: string;
  image?: ImageDetails;
  imageUrl?: string;
}

export interface ImageDetails {
  name: string;
  mimeType: string;
  originalFileName: string;
}

export interface DigitalSignatureDetails {
  name: string;
  mimeType: string;
  originalFileName: string;
  digitalSignatureUrl?: string;
}

export enum Gender {
  Male = 1,
  Female = 2,
}
